/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { ChartParms } from "@src/app/model/sys/nav-item";
import { User } from "@src/app/model/user";
import { NavRoute } from "@src/app/shared/NavRoute";
import { Txn } from "@src/app/model/txn";
import { ArPageComponent } from "@src/app/modules/txn/ar-page/ar-page.component";

export const ArPageNavRoute = new NavRoute(Txn.LEDGER.AR.code, ()=>ArPageComponent, 'call_received').setCharts([
    { type: 'bar', picklist: 'typeId' } as ChartParms,
    { type: 'pie', picklist: 'bCodeId', number: 'credit', excludeZero: true } as ChartParms,
    { type: 'pie', picklist: 'bCodeId', number: 'debit', excludeZero: true } as ChartParms
]).setViews((u: User) => {
    return [
        {
            id: 'currentYear',
            name: 'Current Year',
            helpText: 'Accounts receivable ledger for the current financial year; change the year filter to view a different year',
            filterFields: {
                refNr: null,
                typeId: null,
                txnCycleId: u.currentTeam.currentPeriod?.cycleId,
            },
        }, {
            id: 'outstanding',
            name: 'Outstanding',
            helpText: 'Outstanding service charges and unallocated credits',
            filterFields: {
                typeId: null,
                outstanding: '>=0.01',
            },
            sort: 'createdAt'
        }
    ]
});
